function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M985.598 343.436c0-56.565-39.968-125.289-89.495-153.624L601.497 21.23c-49.428-28.278-129.465-28.335-178.992 0L127.893 189.806c-49.417 28.283-89.49 96.954-89.49 153.63v337.131c0 56.565 39.968 125.289 89.495 153.63l294.606 168.571c49.433 28.283 129.47 28.335 178.997 0l294.601-168.571c49.422-28.283 89.495-96.954 89.495-153.624V343.431z"
});

function SvgHexagon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024"
  }, props), _ref);
}

export default SvgHexagon;